export enum SwipeQuestionChartView {
  INDIVIDUAL,
  TEAMS,
}
